import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getFileUrl } from '../../lib/api';

const categoryLabels = {
  ongoing: 'Devam Eden',
  completed: 'Tamamlanan',
  future: 'Gelecek'
};

export const ProjectNumberCard = ({ project, index }) => {
  const number = String(index + 1).padStart(2, '0');
  const imgSrc = getFileUrl(project.cover_image);

  return (
    <Link
      to={`/proje/${project.slug}`}
      className="group relative overflow-hidden rounded-2xl bg-card border border-border shadow-[var(--shadow-elev-1)] hover:border-[hsl(var(--gold)/0.45)] transition-colors duration-200"
      data-testid="project-card"
    >
      {/* Image */}
      <div className="relative aspect-[16/10] overflow-hidden">
        {imgSrc ? (
          <img
            src={imgSrc}
            alt={project.title}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          />
        ) : (
          <div className="w-full h-full bg-secondary flex items-center justify-center">
            <span className="text-muted-foreground text-sm">Görsel yok</span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
        
        {/* Number */}
        <span className="absolute left-4 top-4 text-3xl font-heading font-semibold tracking-tight tabular-nums text-[hsl(var(--gold))]">
          {number}
        </span>

        {/* Category Badge */}
        <span className="absolute top-4 right-4 px-2.5 py-1 text-xs font-medium rounded-full bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))]">
          {categoryLabels[project.category] || project.category}
        </span>
      </div>

      {/* Content */}
      <div className="p-5">
        <h3 className="font-heading font-semibold text-lg mb-1">{project.title}</h3>
        {project.subtitle && (
          <p className="text-sm text-muted-foreground mb-3">{project.subtitle}</p>
        )}
        <span className="inline-flex items-center gap-1.5 text-sm font-medium text-[hsl(var(--gold))] group-hover:gap-2.5 transition-all duration-200"
              data-testid="project-card-detail-link">
          Projeyi İncele <ArrowRight className="w-4 h-4" />
        </span>
      </div>
    </Link>
  );
};
